import type { ReactNode } from 'react';

type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  desc?: string;
  action?: ReactNode;
};

export default function SectionHeading({ eyebrow, title, desc, action }: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 border-b border-background-200 pb-5 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <span className="inline-flex items-center gap-2 rounded-md bg-primary-100 px-2.5 py-1 text-xs font-bold tracking-wide text-primary-700">
          <i className="ri-price-tag-3-line"></i>
          {eyebrow}
        </span>
        <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">{title}</h2>
        {desc ? <p className="mt-2 text-sm leading-relaxed text-foreground-600">{desc}</p> : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}